import React from 'react';
var createRippleElement = event => {
  var button = event.currentTarget;
  var circle = document.createElement('div');
  var diameter = Math.max(button.clientWidth, button.clientHeight);
  var radius = diameter / 2;
  circle.style.width = "".concat(diameter, "px");
  circle.style.height = "".concat(diameter, "px");
  circle.style.left = "".concat(event.clientX - button.offsetLeft - radius, "px");
  circle.style.top = "".concat(event.clientY - button.offsetTop - radius, "px");
  circle.classList.add('ripple');
  var ripple = button.getElementsByClassName('ripple')[0];
  if (ripple) {
    ripple.remove();
  }
  button.appendChild(circle);
};
var removeRippleElement = buttonRef => {
  var _buttonRef$current;
  (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || (_buttonRef$current = _buttonRef$current.querySelector('.ripple')) === null || _buttonRef$current === void 0 || _buttonRef$current.remove();
};
export var useButton = _ref => {
  var {
    buttonRef,
    disabled = false,
    loading = false,
    onClick = () => {
      /* noop */
    }
  } = _ref;
  // create ripple logic
  var handleClick = event => {
    if (!loading) {
      createRippleElement(event);
      onClick(event);
    }
  };
  // remove ripple logic
  React.useEffect(() => {
    if (disabled || loading) removeRippleElement(buttonRef);
  }, [disabled, loading, buttonRef]);
  return {
    handleClick
  }; // handlers
};